import { render, staticRenderFns } from "./ScanPassBox.vue?vue&type=template&id=39f30b63"
import script from "./ScanPassBox.vue?vue&type=script&lang=js"
export * from "./ScanPassBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports